<app-table
  #table
  [config]="tableConfig"
  [data]="tableData"
  [(selectedElements)]="selectedElements"
></app-table>
